<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content">
      <div class="header-title-admin">{{'' | i18n: 'blacklisted-vins'}}.</div>

      <div class="search-container">
        <div class="search-field" style="float: right;display: flex">{{'' | i18n: 'search-vin'}}:
          <input type="text" name="vinNumber" [(ngModel)]="filter.vin" id="vinNumber" placeholder="{{'' | i18n: 'vehicle-identification-number'}}" style="width: 20%" (keydown.enter)="search()">
          <div class="filter-item-search-btn" style="padding-top: 0px; margin-left: 10px; margin-left: -14px;">
            <button id="refresh" (click)="search()" class="button search-btn">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
          <div class="filter-item-search-btn" style="padding-top: 0px;margin-left: 25px">
            <button (click)="clear()" class="button search-btn">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
          <!--  <button id="clear" (click)="clear()" class="button search-btn">
          <img src="assets/images/BMW-clear-144.png" width="20px" height="20px" style="padding-top: 3px;">
        </button>
        <i _ngcontent-uys-c126="" aria-hidden="true" class="fa fa-search"></i>
        <button id="search" (click)="search()" class="button search-btn">
          <img src="assets/images/BMW-search-144.png" width="20px" height="20px" style="padding-top: 3px;">
        </button>-->
      </div>
    </div>
    <div class="blacklist-container2 mt-4">
      <div class="filter-item-btn">
        {{'' | i18n: 'vin-to-blacklist'}}
        <input type="text" name="dealerName" [(ngModel)]="vin" id="dealerName" placeholder="{{'' | i18n: 'vehicle-identification -number'}}" style="width: auto;">
        <button (click)="addBlacklistVin()" [disabled]="!vin || vin.length !== 17" class="button button-create" style="width: auto;float: right">{{'' | i18n: 'add-to-blacklist'}}</button>
      </div>
    </div>


    <!--<div class="pagecount-container" style="padding-top: 14px">-->
    <!--  <button id="removePage"  (click)="changePage(-1)" class="button button-page" [disabled]="this.filter.page == 0"><img alt="" src="assets/images/BMW-previous-144.png"  width="20px" height="20px"></button>-->
    <!--  <div class="page-text-container"> {{ filter.page + 1 }} </div>-->
    <!--  <button id="addPage" (click)="changePage(1)" class="button button-page" [disabled]="this.vinList?.pageCount > this.filter.page"><img alt="" src="assets/images/BMW-next-144.png"  width="20px" height="20px"></button>-->
  <!--</div>-->

  <div class="form-row-container-blacklist">
    <div class="table-header">
      <!--  <div class="table-header-item-id">
      ID
    </div>
    <div class="table-header-item-lg">
      <a (click)="orderBy('dateCreated')">{{'' | i18n: 'date-created'}}<img *ngIf="filter.orderBy == 'dateCreated'" src="{{showDirectionImage()}}" class="sort-img" alt=""/></a>
    </div>-->
    <div class="table-header-item-lg">
      <a (click)="orderBy('vin')">{{'' | i18n: 'vin'}}@if (filter.orderBy == 'vin') {
        <img src="{{showDirectionImage()}}" class="sort-img" alt=""/>
      }</a>
    </div>
    <div class="table-header-item-id">
      {{'' | i18n: 'remove'}}
    </div>
  </div>
  @for (d of vinList?.dataList; track d) {
    <div class="table-list">
      <!--    <div class="table-list-item-id">
      {{ d.id }}
    </div>
    <div class="table-list-item-lg">
      <label>{{ d.dateCreated }}</label>
    </div>-->
    <div class="table-list-item-lg">
      <label>{{ d.vin }}</label>
    </div>
    <div class="table-list-item-id">
      <!--  <button id="update"  class="button button-edit">
      <img src="assets/images/icon-accept.png" class="table-icon">
    </button>-->
    <i class="fa fa-trash-o" aria-hidden="true" (click)="deleteBlacklistedVin(d)"></i>
  </div>
</div>
}
</div>
</div>
</div>
</div>
